import styled from 'styled-components';
import COLORS from '../../utils/Colors';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 2rem;
`;

export const ReviewElement = styled.div`
    margin-bottom: 3rem;
`;

export const ReviewsCommentsTitle = styled.p`
    font-size: 1.1rem;
    color: ${COLORS.black};
    margin-bottom: 0.3rem;
`;

export const ReviewsCommentsText = styled.p`
    color: ${COLORS.black};
    margin: 0;
`;

export const ReviewTopRow = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 0.7rem;

    & div {
        display: flex;
        justify-content: center;
        flex-direction: column;
        margin-bottom: 1rem;

        & p {
            display: inline;
        }
    }

    & div:last-child {
        margin-left: 1rem;
    }
`;

export const CommentDate = styled.p`
    font-size: 0.8rem;
    color: ${COLORS.hsl210003050};
`;